<template>
  <v-container id="my-business" fluid>
		<v-row align="start" justify="start">
			<v-col cols="2">
				<v-select v-model="filters.entryTypeId" :items="getEntryTypeList" item-value="id" item-text="description" @change="getSeriesCharts()" dense />
			</v-col>
			<v-col cols="2">
				<v-select v-model="filters.currency" :items="getCurrencyList" item-value="code" item-text="code" @change="getDataCharts()" dense />
			</v-col>
			<v-col cols="2">
				<v-select v-model="filters.uom" :items="getUnitOfMeasureList" item-value="code" item-text="code" @change="getDataCharts()" dense />
			</v-col>
		</v-row>
    <v-row align="start" justify="start">
			<v-col cols="6">
        <apexchart width="500" type="bar" :options="optionsChart1" :series="seriesChart1"></apexchart>
			</v-col>
			<v-col cols="6">
        <apexchart width="500" type="bar" :options="optionsChart2" :series="seriesChart2"></apexchart>
			</v-col>
 		</v-row>
		<v-row align="start" justify="start">
			<v-col cols="6">
        <apexchart width="500" type="bar" :options="optionsChart3" :series="seriesChart3"></apexchart>
			</v-col>
			<v-col cols="6">
        <apexchart width="500" type="bar" :options="optionsChart4" :series="seriesChart4"></apexchart>
			</v-col>
		</v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import axios from 'axios'

export default {
	name: 'MyBusiness',
	components: {
		apexchart: VueApexCharts
	},
	data() {
		return {
			filters: {
				entryTypeId: 2,
				currency: 'EUR',
				uom: 'T'
			},
			colors: ['#E2A84E', '#A1A849', '#649F5E', '#329077', '#2E7C85', '#4E647F', '#634B67', '#653745'],
			dataChart1: [],
			seriesChart1: [],
			dataChart2: [],
			seriesChart2: [],
			dataChart3: [],
			seriesChart3: [],
			dataChart4: [],
			seriesChart4: []
		}
	},
	mounted() {
		this.setEntryTypeList()
		this.setCurrencyList()
		this.setUnitOfMeasureList()
		this.getDataCharts()
	},
	methods: {
		groupBy(objectArray, prop) {
			return objectArray.reduce(function (acc, obj) {
				let key = obj[prop]
				if (!acc[key]) {
					acc[key] = []
				}
				acc[key].push(obj)
				return acc
			}, {})
		},
		async getDataChart1() {
			try {
				const response = await axios.get('api/v1/dashboardCharts?id=1&currency=' + this.filters.currency + '&uom=' + this.filters.uom)
				this.dataChart1 = response.data.data
				this.getSeriesChart1()
			} catch (error) {

			}
		},
		getSeriesChart1() {
			const data = this.dataChart1.filter(x => x.entry_type_id === this.filters.entryTypeId)
			const data1 = this.groupBy(data, 'material')
			this.seriesChart1 = []

			for (const prop in data1) {
				let data2 = []
				for (let i = 0; i < data1[prop].length; i++){
					data2.push({x: data1[prop][i].date, y: data1[prop][i].material_value})
				}
				this.seriesChart1.push({name: prop, data: data2})
			}
		},
		async getDataChart2() {
			try {
				const response = await axios.get('api/v1/dashboardCharts?id=2&currency=' + this.filters.currency + '&uom=' + this.filters.uom)
				this.dataChart2 = response.data.data
				this.getSeriesChart2()
			} catch (error) {

			}
		},
		getSeriesChart2() {
			const data = this.dataChart2.filter(x => x.entry_type_id === this.filters.entryTypeId)
			const data1 = this.groupBy(data, 'material')
			this.seriesChart2 = []

			for (const prop in data1) {
				let data2 = []
				for (let i = 0; i < data1[prop].length; i++){
					data2.push({x: data1[prop][i].date, y: data1[prop][i].material_volume})
				}
				this.seriesChart2.push({name: prop, data: data2})
			}			
		},
		async getDataChart3() {
			try {
				const response = await axios.get('api/v1/dashboardCharts?id=3&currency=' + this.filters.currency + '&uom=' + this.filters.uom)
				this.dataChart3 = response.data.data
				this.getSeriesChart3()
			} catch (error) {

			}
		},
		getSeriesChart3() {
			const data = this.dataChart3.filter(x => x.entry_type_id === this.filters.entryTypeId)			
			let data1 = []

			for (let i = 0; i < data.length; i++){
				data1.push({x: data[i].coll_dest_company_name, y: data[i].material_value})
			}

			this.seriesChart3 = []
			this.seriesChart3.push({name: "Material Value", data: data1})
		},
		async getDataChart4() {
			try {
				const response = await axios.get('api/v1/dashboardCharts?id=4&currency=' + this.filters.currency + '&uom=' + this.filters.uom)
				this.dataChart4 = response.data.data
				this.getSeriesChart4()
			} catch (error) {

			}
		},
		getSeriesChart4() {
			const data = this.dataChart4.filter(x => x.entry_type_id === this.filters.entryTypeId)
			let data1 = []

			for (let i = 0; i < data.length; i++){
				data1.push({x: data[i].coll_dest_company_name, y: data[i].material_volume})
			}

			this.seriesChart4 = []
			this.seriesChart4.push({name: "Material Volume", data: data1})
		},
		getDataCharts() {
			this.getDataChart1()
			this.getDataChart2()
			this.getDataChart3()
			this.getDataChart4()
		},
		getSeriesCharts() {
			this.getSeriesChart1()
			this.getSeriesChart2()
			this.getSeriesChart3()
			this.getSeriesChart4()
		},
		...mapActions([
      'setEntryTypeList',
			'setCurrencyList',
			'setUnitOfMeasureList'
		])
	},
	computed: {
    ...mapGetters([
			'getEntryTypeList',
			'getCurrencyList',
			'getUnitOfMeasureList'
		]),
		optionsChart1() {
			try {
				const currency = this.getCurrencyList.filter(x => x.code === this.filters.currency)[0].code
				return {
					chart: { id: 'chart1', stacked: true, toolbar: { show: false, tools: { download: false }}},
					title: { text: 'Material Value by Type' },
					xaxis: { type: 'category', title: { text: 'Year Month' }, labels: { show: true, rotate: -45, rotateAlways: true }},
					yaxis: { type: 'numeric', title: { text: currency }},
					legend: { position: 'right', offsetY: 40 },
					plotOptions: { bar: { hrizontal: false }},
					colors: this.colors
				}
			} catch (error) {
				return {
					chart: { id: 'chart1', stacked: true, toolbar: { show: false, tools: { download: false }}},
					title: { text: 'Material Value by Type' },
					xaxis: { type: 'category', title: { text: 'Year Month' }, labels: { show: true, rotate: -45, rotateAlways: true }},
					yaxis: { type: 'numeric', title: { text: '' }},
					legend: { position: 'right', offsetY: 40 },
					plotOptions: { bar: { hrizontal: false }},
					colors: this.colors
				}
			}
		},
		optionsChart2() {
			try {
				const uom = this.getUnitOfMeasureList.filter(x => x.code === this.filters.uom)[0].code
				return {
					chart: { id: 'chart2', stacked: true, toolbar: { show: false, tools: { download: false }}},
					title: { text: 'Material Volume by Type' },
					xaxis: { type: 'category', title: { text: 'Year Month' }, labels: { show: true, rotate: -45, rotateAlways: true }},
					yaxis: { type: 'numeric', title: { text: uom }},
        	legend: { position: 'right', offsetY: 40 },
					plotOptions: { bar: { hrizontal: false }},
					colors: this.colors
				}
			} catch (error) {
				return {
					chart: { id: 'chart2', stacked: true, toolbar: { show: false, tools: { download: false }}},
					title: { text: 'Material Volume by Type' },
					xaxis: { type: 'category', title: { text: 'Year Month' }, labels: { show: true, rotate: -45, rotateAlways: true }},
					yaxis: { type: 'numeric', title: { text: '' }},
        	legend: { position: 'right', offsetY: 40 },
					plotOptions: { bar: { hrizontal: false }},
					colors: this.colors
				}
			}
		},
		optionsChart3() {
			try {
				const currency = this.getCurrencyList.filter(x => x.code === this.filters.currency)[0].code
				return {
					chart: { id: 'chart3', stacked: false, toolbar: {show: false, tools: { download: false }}},
					title: { text: 'Top 10 Companies by Value' },
					xaxis: { type: 'numeric', title: { text: currency }},
					yaxis: { type: 'category', title: { text: 'Company' }},
        	legend: { position: 'right', offsetY: 40 },
					plotOptions: { bar: { horizontal: true }},
					colors: this.colors
				}
			} catch (error) {
				return {
					chart: { id: 'chart3', stacked: false, toolbar: {show: false, tools: { download: false }}},
					title: { text: 'Top 10 Companies by Value' },
					xaxis: { type: 'numeric', title: { text: '' }},
					yaxis: { type: 'category', title: { text: 'Company' }},
        	legend: { position: 'right', offsetY: 40 },
					plotOptions: { bar: { horizontal: true }},
					colors: this.colors
				}
			}
		},
		optionsChart4() {
			try {
				const uom = this.getUnitOfMeasureList.filter(x => x.code === this.filters.uom)[0].code
				return {
					chart: { id: 'chart4', stacked: false, toolbar: {show: false, tools: { download: false }}},
					title: { text: 'Top 10 Companies by Volume' },
					xaxis: { type: 'numeric', title: { text: uom }},
					yaxis: { type: 'category', title: { text: 'Company'}},
        	legend: { position: 'right', offsetY: 40 },
					plotOptions: { bar: { horizontal: true }},
					colors: this.colors
				}
			} catch (error) {
				return {
					chart: { id: 'chart4', stacked: false, toolbar: {show: false, tools: { download: false }}},
					title: { text: 'Top 10 Companies by Volume' },
					xaxis: { type: 'numeric', title: { text: '' }},
					yaxis: { type: 'category', title: { text: 'Company'}},
        	legend: { position: 'right', offsetY: 40 },
					plotOptions: { bar: { horizontal: true }},
					colors: this.colors
				}
			}			
		}
	}
}
</script>